import { render, staticRenderFns } from "./AddUrlToList.vue?vue&type=template&id=445a249f&scoped=true&"
import script from "./AddUrlToList.vue?vue&type=script&lang=js&"
export * from "./AddUrlToList.vue?vue&type=script&lang=js&"
import style0 from "./AddUrlToList.vue?vue&type=style&index=0&id=445a249f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445a249f",
  null
  
)

export default component.exports